import { useState } from 'react'
import { patch } from '../lib/api.ts'
import { lang, setLang, t, type Lang } from '../lib/i18n.ts'
import { cn } from './ui.tsx'

/** Each language is named in itself, as language pickers do, so nobody has to read the other one to switch back. */
const LANGS: [Lang, string][] = [['pt-BR', 'Português'], ['en', 'English']]

/**
 * The interface language (ADR 0040). Choosing one stores it in this browser, on the account when signed in (so a new
 * device starts in it), and reloads the page in that language.
 */
export function LanguageToggle({ signedIn, className }: { signedIn: boolean; className?: string }) {
  const [busy, setBusy] = useState(false)
  const choose = async (next: Lang) => {
    if (next === lang) return
    setBusy(true)
    try {
      if (signedIn) await patch('/api/me', { locale: next })
    } catch {
      // the account keeps its old choice; this browser still switches
    }
    setLang(next)
  }
  return (
    <span role="group" aria-label={t('Idioma')} className={cn('inline-flex gap-1', className)}>
      {LANGS.map(([code, name]) => (
        <button key={code} type="button" lang={code} aria-pressed={lang === code} disabled={busy} onClick={() => void choose(code)} className={cn('min-h-9 rounded px-2', lang === code ? 'font-semibold text-tinta' : 'text-caneta underline')}>
          {name}
        </button>
      ))}
    </span>
  )
}
